
export default function (dom, opts) {
	var options = {
		classes: {
			loggedInStatusCls: 'logged-in',
			logoutCls: 'logout'
		},
		selectors: {
			modSel: '.mod_login'
		},

		...opts
	};

	const html = document.documentElement;
	const body = document.body;
	const findMod = dom.querySelector(options.selectors.modSel);

	init()

	function init() {
		if (findMod.classList.contains(options.classes.logoutCls)) {
			document.body.classList.add(options.classes.loggedInStatusCls);
		}
	}
}
